import React from 'react';
import {
  Text,
  Table,
  Thead,
  Tr,
  Th,
  Tbody,
  Td,
  Center,
  Box,
} from '@chakra-ui/react';
import Reveal from './Reveal';

const TrackerAppTable = () => {
  return (
    <Reveal>
      <Box overflow="auto" mt={8} mb={8}>
        <Table variant="simple" size="lg">
          <Thead>
            <Tr>
              <Th>Method</Th>
              <Th>Route</Th>
              <Th>Response</Th>
            </Tr>
          </Thead>
          <Tbody>
            <Tr>
              <Td>GET*</Td>
              <Td>/tracks</Td>
              <Td>Returns a list of tracks that the user have created.</Td>
            </Tr>
            <Tr>
              <Td>POST*</Td>
              <Td>/tracks</Td>
              <Td>
                App tries to confirm if the request body have the appropriate
                data and will try to save that into database. Will send back
                success message or an error message as a response.
              </Td>
            </Tr>
            <Tr>
              <Td>POST</Td>
              <Td>/signup</Td>
              <Td>
                App will check if the database already have the email/username.
                If the email/username is available, App will generate an
                encrypted password and try to save the user into database. Will
                send a JWT or an error message as a response.
              </Td>
            </Tr>
            <Tr>
              <Td>POST</Td>
              <Td>/signin</Td>
              <Td>
                App will search for the given email/username in the database. If
                it founds one, then the App will compare the password given with
                the encrypted password on the database. Will send a JWT or an
                error message as a response.
              </Td>
            </Tr>
          </Tbody>
        </Table>
        <Center mt={4}>
          <Text align="center">
            * = Request must be made with Authorization header. Ex: "Bearer{' '}
            {'<JWT>'}"
          </Text>
        </Center>
      </Box>
    </Reveal>
  );
};

export default TrackerAppTable;
